module.exports = __webpack_public_path__ + "static/colourmomentsmain-dc937b1ebe108986ce990bb6c4e370d0.jpeg";